// ============================================================================
// equipment.fueling.supply — receipt-backed no-server-read surface
// ============================================================================
// FuelingHub resolves this exact sub-route before its schema/error/loading
// screens. Its equipment resource is explicitly disabled for `supply`, and
// FuelSupplyWebform has no render read of its own. The only reachable server
// operation is the user-initiated/queued fuel_supplies INSERT owned by the
// shared offline submit command path; that mutation is not a render read. The
// separate boot-release ledger and release receipt, not this declaration,
// authorize independent boot timing.
// ============================================================================

import type {NoServerReadSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: NoServerReadSurfaceDeclaration = Object.freeze({
  surface: 'equipment.fueling.supply',
  disposition: 'no-server-read',
});

export default declaration;
